import { AlertTriangle } from "lucide-react";
import { EMERGENCY_MESSAGE } from "@/config/incidentCatalog";

export function EmergencyNotice() {
  return (
    <div data-testid="emergency-notice" role="alert"
      className="rounded-md border border-red-300 bg-red-50 px-4 py-3 text-sm text-red-900 flex gap-3">
      <AlertTriangle className="h-5 w-5 shrink-0 mt-0.5" />
      <p>{EMERGENCY_MESSAGE}</p>
    </div>
  );
}
